export default __webpack_public_path__ + "static/media/KR.094b4c1c.svg";